/**
 * jQuery Bar Rating Plugin v1.1.0
 *
 * http://github.com/antennaio/jquery-bar-rating
 *
 * Copyright (c) 2012-2015 Kazik Pietruszewski
 *
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 */
(function ($) {
    var BarRating, root;

    root = typeof window !== "undefined" && window !== null ? window : global;

    root.BarRating = BarRating = (function() {

        function BarRating() {
            var self = this;

            // wrap element in a wrapper div
            var wrapElement = function() {
                self.$elem.wrap($('<div />', {
                    'class': self.options.wrapperClasses.join(" ")
                }));
            };

            // unwrap element
            var unwrapElement = function() {
                self.$elem.unwrap();
            };

            // return initial option
            var findInitialOption = function() {
                var option;

                if (self.options.initialRating) {
                    option = $('option[value="' + self.options.initialRating  + '"]', self.$elem);
                } else {
                    option = $('option:selected', self.$elem);
                }

                return option;
            };

            // save data on element
            var saveDataOnElement = function() {
                var $opt = findInitialOption();

                self.$elem.data('barrating', {

                    userOptions: self.options,

                    // initial rating based on the OPTION value
                    currentRatingValue: $opt.val(),
                    currentRatingText: ($opt.data('html')) ? $opt.data('html') : $opt.text(),

                    // rating will be restored by calling clear method
                    originalRatingValue: $opt.val(),
                    originalRatingText: ($opt.data('html')) ? $opt.data('html') : $opt.text()

                });

                // first OPTION empty - allow deselecting of ratings
                self.$elem.data('barrating').deselectable = false;
            
            };

            // remove data on element
            var removeDataOnElement = function() {
                self.$elem.removeData('barrating');
            };

            // build widget and return jQuery element
            var buildWidget = function() {
                var $w = $('<div />', { 'class': 'br-widget' });

                // create A elements that will replace OPTIONs
                var index = 0
                self.$elem.find('option').each(function() {
                    var val, text, html, $a, $span;

                    val = $(this).val();

                    // create ratings - but only if val is defined
                    if (val) {
                        text = $(this).text();
                        html = $(this).data('html');
                        if (html) { text = html; }
                        var lbl = $(this).attr('data-rating-label');
                        var icon = $(this).attr('data-rating-icon');
                        if (!lbl) { lbl = text; }
                        

                        $a = $('<a />', { 'href': '#', 'data-rating-value': val, 'data-rating-text': lbl, 'data-index': index });
                        $span = $('<span />', { 'html': (self.options.showValues && !self.options.useIcons) ? text : '' });
                        
                        $w.append($a.append($span));     
                        
                        if( self.options.useIcons && icon != "" ){
                          var imagePath = localFilePath( '/images/ratings/' + icon.replace("icon_set", "set") + '.png' )
                          $a.css( { "background-image": 'url("' + imagePath + '")' } )
                          $a.attr( "data-has-rating-icon", icon );
                        }                   
                        index += 1;
                    }

                });

                // append .br-current-rating div to the widget
                if (self.options.showSelectedRating) {
                    //$w.append($('<div />', { 'text': '', 'class': 'br-current-rating' }));
                }

                // additional classes for the widget
                if (self.options.reverse) {
                    $w.addClass('br-reverse');
                }

                if (self.options.readonly) {
                    $w.addClass('br-readonly');
                }

                return $w;
            };

            // return a jQuery function name depending on the 'reverse' setting
            var nextAllorPreviousAll = function() {
              if (self.options.single) {
                return 'closest';
              } else if (self.options.reverse) {
                return 'nextAll';
              } else {
                return 'prevAll';
              }
            };

            // set the value of the select field
            var setSelectFieldValue = function(value) {
                // change selected OPTION in the select field (hidden)
                self.$elem.find('option[value="' + value + '"]').prop('selected', true);
                self.$elem.change();
            }

            // display the currently selected rating
            var showSelectedRating = function(text, $a) {
              // update .br-current-rating div
                  if (self.options.showSelectedRating) {
                    if( !text ){
                      var barData = self.$elem.data('barrating')
                      if( barData ){
                        text = barData.currentRatingText
                      }                  
                    }
                    
                    var $currRate = self.$elem.parent().parent().find('.br-current-rating')
                    $currRate.text(text);
                    
                    // Fancy text alignment when text displays on mouse-over/tap.
                    // left items left-align to left of box
                    // right items right-align to right of box
                    // middle item center-align

                    if( !self.$elem.data('barrating') ){
                      return;
                    }
                    
                    if( !$a ){
                      $a = self.$elem.parent().parent().find('a[data-rating-value="' + self.$elem.data('barrating').currentRatingValue + '"]')
                    }
                    if( text && text != '' && $a ){
                      /// set up defaults
                      $currRate.width( "100%" )
                      $currRate.css({'text-align': 'center', 'padding-left' : "0px"})
                      
                      // Don't bother if the boxes have wrapped
                      var firstBox = $a.parent().find("a:first")
                      var lastBox = $a.parent().find("a:last")
                      
                      if( firstBox.position().top == lastBox.position().top )
                      {  
                        // right & center align need the text div to match box div width
                        var fullWidth = (lastBox.position().left + lastBox.outerWidth(true)) - firstBox.position().left
                        $currRate.width( fullWidth )
                                                                      
                        var index = parseInt( $a.attr("data-index") )
                        var total = $a.parent().find("a").length
                        var middle = total/2 - 0.5
                        
                        var left = $a.position().left - $a.parent().position().left
                        
                        if( index < middle){                      
                          $currRate.css({'text-align': 'left', 'padding-left' : (left + 6) +"px"})
                        } else if( index > middle){
                          var width = (left - 6) + $a.outerWidth(true)
                          $currRate.width( width )
                          $currRate.css({'text-align': 'right', 'padding-left' : "0px"})
                        } else {
                          $currRate.css({'text-align': 'center', 'padding-left' : "0px", 'width': '100%'})
                        }
                      }
                    }
                }
            };

            // apply style by setting classes on elements
            var applyStyle = function($w) {
                // remove classes
                $w.find('a').removeClass('br-selected br-current');

                // add classes
                $w.find('a[data-rating-value="' + self.$elem.data('barrating').currentRatingValue + '"]')
                    .addClass('br-selected br-current')[nextAllorPreviousAll()]()
                    .addClass('br-selected');
            };

            // handle click events
            var attachClickHandler = function($all) {
                $all.on('click', function(event) {
                    var $a = $(this),
                        value,
                        text;

                    event.preventDefault();

                    $all.removeClass('br-active br-selected');
                    $a.addClass('br-selected')[nextAllorPreviousAll()]()
                        .addClass('br-selected');

                    value = $a.attr('data-rating-value');
                    text = $a.attr('data-rating-text');

                    // is current and deselectable?
                    if ($a.hasClass('br-current') && self.$elem.data('barrating').deselectable) {
                        $a.removeClass('br-selected br-current')[nextAllorPreviousAll()]()
                            .removeClass('br-selected br-current');
                        value = ''; text = '';
                    } else {
                        $all.removeClass('br-current');
                        $a.addClass('br-current');
                    }

                    // remember selected rating
                    self.$elem.data('barrating').currentRatingValue = value;
                    self.$elem.data('barrating').currentRatingText = text;

                    setSelectFieldValue(value);
                    showSelectedRating(text, $a);

                    // onSelect callback
                    self.options.onSelect.call(
                        this,
                        self.$elem.data('barrating').currentRatingValue,
                        self.$elem.data('barrating').currentRatingText,
                        self.$elem
                    );

                    return false;
                });
            };

            // handle resize events
            var attachResizeHandler = function() {
              $(window).resize(function(){
                showSelectedRating();
              });
            };

            // handle mouseenter events
            var attachMouseEnterHandler = function($all) {
                $all.on({
                    mouseenter: function() {
                        var $a = $(this);

                        $all.removeClass('br-active br-selected');
                        $a.addClass('br-active')[nextAllorPreviousAll()]()
                            .addClass('br-active');

                        showSelectedRating($a.attr('data-rating-text'), $a);
                    }
                });
            };

            // handle mouseleave events
            var attachMouseLeaveHandler = function($all, $widget) {
                $widget.on({
                    mouseleave: function() {
                        $all.removeClass('br-active');
                        showSelectedRating();
                        applyStyle($widget);
                    }
                });
            };

            // somewhat primitive way to remove 300ms click delay on touch devices
            // for a more advanced solution consider setting `fastClicks` option to false
            // and using a library such as fastclick (https://github.com/ftlabs/fastclick)
            var fastClicks = function($all) {
                $all.on('touchstart', function(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    $(this).click();
                });
            };

            // disable clicks
            var disableClicks = function($all) {
                $all.on('click', function(event) {
                    event.preventDefault();
                });
            };

            this.show = function() {
                var $widget, $all;

                // run only once
                if (self.$elem.data('barrating')) return;

                // wrap element
                wrapElement();

                // save data
                saveDataOnElement();

                // build & append widget to the DOM
                $widget = buildWidget();
                $widget.insertAfter(self.$elem);
                applyStyle($widget);

                showSelectedRating();

                $all = $widget.find('a');

                if (self.options.fastClicks) {
                    fastClicks($all);
                }

                if (self.options.readonly) {

                    // do not react to click events if rating is read-only
                    disableClicks($all);

                } else {

                    // attach click event handler
                    attachClickHandler($all);

                    // attach mouseenter event handler
                    attachMouseEnterHandler($all);

                     // attach mouseleave event handler
                    attachMouseLeaveHandler($all, $widget);
                    
                    attachResizeHandler()

                }

                // hide the select field
                self.$elem.hide();
            };

            this.set = function(value) {
                if (!this.$elem.find('option[value="' + value + '"]').val()) return;

                // set data
                this.$elem.data('barrating').currentRatingValue = value;
                this.$elem.data('barrating').currentRatingText = this.$elem.find('option[value="' + value + '"]').text();

                setSelectFieldValue(this.$elem.data('barrating').currentRatingValue);
                showSelectedRating(this.$elem.data('barrating').currentRatingText);

                applyStyle(this.$widget);
            };

            this.clear = function() {
                // restore original data
                this.$elem.data('barrating').currentRatingValue = this.$elem.data('barrating').originalRatingValue;
                this.$elem.data('barrating').currentRatingText = this.$elem.data('barrating').originalRatingText;

                setSelectFieldValue(this.$elem.data('barrating').currentRatingValue);
                showSelectedRating(this.$elem.data('barrating').currentRatingText);

                applyStyle(this.$widget);

                // onClear callback
                this.$elem.data('barrating').userOptions.onClear.call(
                    this,
                    this.$elem.data('barrating').currentRatingValue,
                    this.$elem.data('barrating').currentRatingText
                );
            };

            this.destroy = function() {
                var value = this.$elem.data('barrating').currentRatingValue;
                var text = this.$elem.data('barrating').currentRatingText;
                var options = this.$elem.data('barrating').userOptions;

                this.$widget.off().remove();

                // remove data
                removeDataOnElement();

                // unwrap the element
                unwrapElement();

                // show the element
                this.$elem.show();

                // onDestroy callback
                options.onDestroy.call(
                    this,
                    value,
                    text
                );
            };
        }

        BarRating.prototype.init = function (options, elem) {
            this.$elem = $(elem);

            return this.options = $.extend({}, $.fn.barrating.defaults, options);
        };

        return BarRating;
    })();

    $.fn.barrating = function (method, options) {
        return this.each(function () {
            var plugin = new BarRating();

            // plugin works with select fields
            if (!$(this).is('select')) {
                $.error('Sorry, this plugin only works with select fields.');
            }

            // method supplied
            if (plugin.hasOwnProperty(method)) {
                plugin.init(options, this);
                if (method === 'show') {
                    return plugin.show(options);
                } else {
                    // plugin exists?
                    if (plugin.$elem.data('barrating')) {
                        plugin.$widget = $(this).next('.br-widget');
                        return plugin[method](options);
                    }
                }

            // no method supplied or only options supplied
            } else if (typeof method === 'object' || !method) {
                options = method;
                plugin.init(options, this);
                return plugin.show();

            } else {
                $.error('Method ' + method + ' does not exist on jQuery.barrating');
            }
        });
    };

    return $.fn.barrating.defaults = {
        initialRating:null, // initial rating
        showValues:false, // display rating values on the bars?
        showSelectedRating:true, // append a div with a rating to the widget?
        useIcons:false,
        single:true, // select only the current rating
        reverse:false, // reverse the rating?
        readonly:false, // make the rating ready-only?
        fastClicks:true, // remove 300ms click delay on touch devices?
        wrapperClasses:['br-wrapper'], // class applied to wrapper div
        onSelect:function (value, text, elem) {
        }, // callback fired when a rating is selected
        onClear:function (value, text) {
        }, // callback fired when a rating is cleared
        onDestroy:function (value, text) {
        } // callback fired when a widget is destroyed
    };

})(jQuery);